window.addEventListener("load", function () {
  const panel = document.getElementById("nth-ld-frame2-menu-mb");
  if (!panel) return;

  const main = document.getElementById("nth-ld-frame2");
  const nav = document.getElementById("vxphl-ld-25-a-navigation");
  const btnMenu = nav ? nav.querySelector(".btn-menu") : null;

  // ===== Milestone: auto active dots + bar-active width theo data-progress (%) =====
  // % của center mỗi dot trên thanh bar 625px (dot tại left: 37/179/322/464/606, +16 center, -1 bar offset)
  const DOT_PERCENTS = [8.32, 31.04, 53.92, 76.64, 99.36];
  panel.querySelectorAll(".vote-milestones[data-progress]").forEach(function (m) {
    const pct = Math.max(0, Math.min(100, parseFloat(m.dataset.progress) || 0));
    const barActive = m.querySelector(".bar-active");
    if (barActive) barActive.style.width = pct + "%";
    m.querySelectorAll(".vote-milestones__dot").forEach(function (dot, i) {
      dot.classList.toggle("dot-active", pct >= DOT_PERCENTS[i]);
    });
  });

  // ===== Toggle panel khi click .btn-menu trong navigation =====
  if (btnMenu) {
    btnMenu.addEventListener("click", function (e) {
      e.preventDefault();
      const isActive = panel.classList.toggle("active");
      if (nav) nav.classList.toggle("active", isActive);
      if (main) main.style.display = isActive ? "none" : "";

      // Khi mở menu-mb: đóng search-mb nếu đang active
      if (isActive) {
        const searchMb = document.getElementById("nth-ld-frame2-search-mb");
        if (searchMb) searchMb.classList.remove("active");
      }

      window.dispatchEvent(new Event("resize"));
    });
  }
});
